import { render, staticRenderFns } from "./DeleteAction.vue?vue&type=template&id=524e286e&scoped=true&"
import script from "./DeleteAction.vue?vue&type=script&lang=js&"
export * from "./DeleteAction.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAction.vue?vue&type=style&index=0&id=524e286e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e286e",
  null
  
)

export default component.exports